import React from "react";

export default function UserViewSkeleton() {
  return (
    <div className="min-h-screen px-4 py-6 animate-pulse">
      {/* Header Skeleton */}
      <div className="rounded-3xl bg-gradient-to-r from-gray-100 to-gray-200 shadow-md p-6 mb-6">
        <div className="flex flex-col lg:flex-row justify-between gap-6">
          {/* Left (Profile Info) */}
          <div className="flex items-center gap-4">
            <div className="h-16 w-16 rounded-2xl bg-gray-300" />
            <div className="space-y-2">
              <div className="h-5 w-48 bg-gray-300 rounded" />
              <div className="h-4 w-32 bg-gray-200 rounded" />
              <div className="flex flex-wrap gap-2 mt-2">
                <div className="h-3 w-24 bg-gray-200 rounded" />
                <div className="h-3 w-20 bg-gray-200 rounded" />
                <div className="h-3 w-28 bg-gray-200 rounded" />
              </div>
            </div>
          </div>

          {/* KPI Small Boxes */}
          <div className="grid grid-cols-2 sm:grid-cols-4 gap-3 w-full sm:w-auto">
            {[...Array(2)].map((_, i) => (
              <div
                key={i}
                className="rounded-2xl bg-gray-300/70 h-16 w-full"
              />
            ))}
          </div>
        </div>

        {/* KPI Cards */}
        <div className="mt-6 grid gap-4 grid-cols-2 sm:grid-cols-2 lg:grid-cols-4">
          {[...Array(4)].map((_, i) => (
            <div
              key={i}
              className="rounded-2xl bg-gray-300/60 h-24"
            />
          ))}
        </div>
      </div>

      {/* Tabs Skeleton */}
      <div className="bg-gray-50 rounded-xl p-4 shadow-sm">
        <div className="flex justify-center mb-4">
          <div className="flex gap-2">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="h-8 w-20 bg-gray-200 rounded-lg" />
            ))}
          </div>
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="h-64 bg-gray-100 rounded-xl" />
          <div className="h-64 bg-gray-100 rounded-xl" />
        </div>
      </div>
    </div>
  );
}

